import type { Nullable } from '@enmon/commons';

export const localeSort = (a?: Nullable<string>, b?: Nullable<string>): number => {
  if (!(a && b)) return 0;
  return a.toLowerCase().localeCompare(b.toLowerCase());
};
